/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_3_QuestionInputs */

const en_gc_search_guides_what_is_gridcraft_sections_8_questions_3_question = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I learn with GridCraft before moving my own files?`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_8_questions_3_question = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_3_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`能否先学习，再迁移自己的文件？`)
};

/**
* | output |
* | --- |
* | "Can I learn with GridCraft before moving my own files?" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_3_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_8_questions_3_question = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_3_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_8_Questions_3_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_8_questions_3_question(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_8_questions_3_question(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_8_questions_3_question as "gc.search_guides.what_is_gridcraft.sections.8.questions.3.question" }